import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Logo from "../../img/powered_by_hg_logo.png";
import moment from "moment";
import "./EmbedGig.css";
import "./details/EmbedGigGridDetails.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const maxText = 500;

@inject("embedGigStore", "gigPromotionStore")
@withRouter
@observer
class EmbedGigOrganisationLarge extends Component {
    state = {
        finishLoading: false,
        performData: null,
        tableBgColor: "#ffffff",
        tableFtColor: "#000000",
        tableWidgetBgColor: "transparent",
        hideToolbar: false,
        brokenImages: {},
    };

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.loadData();
        }
    }

    loadData = () => {
        const organisationId = this.props.match.params.id;
        const queryString = this.props.location.search;
        const params = new URLSearchParams(queryString);

        const startDate = params.get("startDate") || moment().startOf("month").format("MM-DD-YYYY");
        const endDate   = params.get("endDate")   || moment().add(4, "months").endOf("month").format("MM-DD-YYYY");
        const utcOffset = params.get("utcOffset") != null ? params.get("utcOffset") : null;
        const page      = params.get("page") || "1";
        const take      = params.get("take") || "20";
        const venueIds  = params.getAll("venueIds[]");

        const filterParams = { startDate, endDate, page, take };
        if (utcOffset != null) filterParams.utcOffset = utcOffset;
        if (venueIds.length > 0) filterParams.venueIds = venueIds;

        this.props.embedGigStore.loadEmbedCodeOrganisation(organisationId).then(() => {
            const store = this.props.embedGigStore;
            this.setState({
                tableBgColor: store.tableBgColor || "#ffffff",
                tableFtColor: store.tableFtColor || "#000000",
                tableWidgetBgColor: store.tableWidgetBgColor ? "#" + store.tableWidgetBgColor.replace("#", "") : "transparent",
                hideToolbar: store.hideToolbar || false,
            });
        });

        this.props.gigPromotionStore.loadOrganisationEmbedGigs(organisationId, filterParams).then(gigs => {
            this.setState({ finishLoading: true, performData: this.processGigs(gigs) });
        }).catch(() => {
            this.setState({ finishLoading: true, performData: [] });
        });
    };

    processGigs = (gigs) => {
        if (!gigs || gigs.length === 0) return [];

        return gigs.slice().sort((a, b) => {
            const da = a.dateStart || "";
            const db = b.dateStart || "";
            return da < db ? -1 : da > db ? 1 : 0;
        }).map(gig => {
            const dateStart = moment(gig.dateStart);
            const actName   = gig.actName || (gig.act && (gig.act.actName || gig.act.profileName)) || "Unknown Act";
            const venueName = gig.venueName || (gig.venue && gig.venue.profileName) || "";
            const cardImage = gig.resolvedImageUrl
                || (gig.act && gig.act.resolvedProfileImage)
                || (gig.venue && gig.venue.resolvedBackgroundImage)
                || BASE_URL + "hero2.jpg";

            const rawBio = (gig.act && gig.act.actDescription) || gig.actDescription || "";
            const shortBio = rawBio.length > maxText ? rawBio.substring(0, maxText) + "..." : rawBio;

            return {
                eventId: gig.id,
                year: dateStart.format("YYYY"),
                month: dateStart.format("MMMM"),
                date: dateStart.format("D"),
                day: dateStart.format("dddd"),
                time: gig.timeStart
                    ? moment(gig.timeStart, "HH:mm:ss").format("h.mma") + (gig.timeEnd ? " - " + moment(gig.timeEnd, "HH:mm:ss").format("h.mma") : "")
                    : "",
                actName,
                venueName,
                cardImage,
                actId: (gig.act && gig.act.id) || gig.actId || null,
                actGenres: gig.act && gig.act.actGenres ? gig.act.actGenres.map(g => g.name).join(", ") : "",
                bio: rawBio,
                shortBio,
                expandableBio: rawBio.length > maxText,
                expandBio: false,
            };
        });
    };

    handleImgError = (key) => {
        this.setState(prev => ({ brokenImages: { ...prev.brokenImages, [key]: true } }));
    };

    toggleBio = (index) => {
        const tempData = [...this.state.performData];
        tempData[index] = { ...tempData[index], expandBio: !tempData[index].expandBio };
        this.setState({ performData: tempData });
    };

    render() {
        const { performData, tableBgColor, tableFtColor, tableWidgetBgColor, hideToolbar, brokenImages } = this.state;

        return (
            <Fragment>
                <Paper>
                    {!hideToolbar && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "12px 16px", borderBottom: "1px solid #eee" }}>
                            <Typography variant="caption" style={{ paddingRight: 8 }}>Powered By</Typography>
                            <img src={Logo} alt="hotgiggity logo" height="30px" />
                        </div>
                    )}
                    <div className={!hideToolbar ? "gig-table-container" : ""}>
                        <Table>
                            <TableBody>
                                {performData && performData.map((data, index) => (
                                    <TableRow key={data.eventId || index} style={{ verticalAlign: "top" }}>
                                        <TableCell className="gig-column" style={{ width: "40%", backgroundColor: tableBgColor, padding: 0 }}>
                                            <Card style={{ borderRadius: 0, boxShadow: "none" }}>
                                                <CardActionArea onClick={() => data.actId && window.open(`${BASE_URL}profile/${data.actId}`)}>
                                                    {brokenImages[data.eventId] ? (
                                                        <div style={{ width: "100%", minHeight: 280, backgroundColor: tableWidgetBgColor !== "transparent" ? tableWidgetBgColor : tableBgColor }} />
                                                    ) : (
                                                        <img
                                                            className="imageStyleDetailInfo"
                                                            src={data.cardImage}
                                                            alt={data.actName}
                                                            style={{ width: "100%", display: "block" }}
                                                            onError={() => this.handleImgError(data.eventId)}
                                                        />
                                                    )}
                                                </CardActionArea>
                                            </Card>
                                        </TableCell>
                                        <TableCell className="gig-column" style={{ backgroundColor: tableBgColor }}>
                                            <div style={{ padding: 10 }}>
                                                <Typography
                                                    variant="h5"
                                                    gutterBottom
                                                    style={{ color: tableFtColor, display: "inline", borderBottom: "solid 1px " + tableFtColor, cursor: data.actId ? "pointer" : "default" }}
                                                    onClick={() => data.actId && window.open(`${BASE_URL}profile/${data.actId}`)}
                                                >
                                                    {data.actName}
                                                </Typography>
                                                {data.venueName ? (
                                                    <Typography component="p" gutterBottom style={{ fontStyle: "italic", fontSize: "small", color: tableFtColor, marginTop: 6 }}>
                                                        {data.venueName}
                                                    </Typography>
                                                ) : null}
                                                {data.actGenres ? (
                                                    <Typography component="p" gutterBottom style={{ fontStyle: "italic", fontSize: "small", color: tableFtColor }}>
                                                        {data.actGenres}
                                                    </Typography>
                                                ) : null}
                                                <Typography variant="body1" style={{ color: tableFtColor, marginTop: 8 }}>
                                                    {`${data.day}, ${data.date} ${data.month} ${data.year} ${data.time}`}
                                                </Typography>
                                                {data.bio ? (
                                                    <Typography
                                                        component="div"
                                                        style={{ color: tableFtColor, marginTop: 8 }}
                                                        dangerouslySetInnerHTML={{ __html: data.expandableBio ? (data.expandBio ? data.bio : data.shortBio) : data.bio }}
                                                    />
                                                ) : null}
                                                {data.expandableBio ? (
                                                    <Typography
                                                        component="a"
                                                        variant="body1"
                                                        onClick={() => this.toggleBio(index)}
                                                        style={{ cursor: "pointer", color: "#337ab7" }}
                                                    >
                                                        {!data.expandBio ? "Show More" : "Show Less"}
                                                    </Typography>
                                                ) : null}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {performData && performData.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ backgroundColor: tableBgColor, textAlign: "center", padding: "40px 20px" }}>
                                            <Typography style={{ color: tableFtColor }}>No upcoming gigs found.</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
                {hideToolbar && (
                    <div className="embed-footer-grid" style={{ textAlign: "center", padding: "20px 0" }}>
                        <img className="imageFooter" onClick={() => window.open("https://hotgiggity.com", "_system")} alt="hotgiggity logo" src={Logo} height="40px" />
                    </div>
                )}
            </Fragment>
        );
    }
}

export default EmbedGigOrganisationLarge;
